export const GET_COMMENT_LIST = 'comment/GET_COMMENT_LIST'
export const INIT_COMMENT_LIST = 'comment/INIT_COMMENT_LIST'
